import { useTranslation } from "react-i18next";
import { DefaultInput } from "./DefaultInput";
import React from "react";

interface SellingStrategyValueInputProps {
    setValues: (value: number, key: string) => void;
    disabled: boolean;
    value: number;
    iconKey: string;
    valuekey?: string;
    isPercentage?: boolean
}

export const SellingStrategyValueInput = (props: SellingStrategyValueInputProps) => {    
    const { t } = useTranslation();
    return (
        <>
            <DefaultInput
                onChange={(value: any) => props.setValues(parseFloat(value), props.valuekey ? props.valuekey : "sellingStrategyValue")}
                type="number"
                iconKey={props.iconKey}
                placeholder={t("txt_value")}
                disabled={props.disabled}
                value={props.value}
                params={{numberIsInterger: true, numberIsPercentage: props.isPercentage}}
            />
        </>
    )
}